import {
  Component,
  HostListener,
  OnInit,
  Output,
  ViewChild,
  EventEmitter,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import moment from 'moment';
import { AlertComponent } from '../../../../alert/alert.component';
import { LoadingModalComponent } from '../../../../loading-modal/loading-modal.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { PickerComponent } from '@ctrl/ngx-emoji-mart';
import { DisparoService } from '../disparo.service';
import { Subject, map, takeUntil } from 'rxjs';

@Component({
  selector: 'app-fire-csv',
  standalone: true,
  imports: [
    MatIconModule,
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    AlertComponent,
    LoadingModalComponent,
    PickerComponent,
  ],
  templateUrl: './fire-csv.component.html',
  styleUrls: ['./fire-csv.component.scss'],
  providers: [DisparoService],
})
export class FireCsvComponent implements OnInit {
  //Variables of loading and alert
  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @ViewChild(LoadingModalComponent) loadingComponent!: LoadingModalComponent;

  //Inputs and Outputs
  @Output() closeModal: EventEmitter<number> = new EventEmitter<number>();

  //Unsubscribe
  private unsubscribe$: Subject<void> = new Subject();

  //Variables of Modal new fire
  public modalNewFire: boolean = false;
  public selectedFire: boolean = false;
  public selectedTypeForm?: string;
  public countInputFile: number = 0;
  public listMessages!: Array<any>;
  public listChannels!: Array<any>;
  public isEmojiPickerVisible: boolean = false;
  public isScheduled: boolean = false;
  public formattedDate!: string;
  public errorMessage: string | null = null;
  public acceptTerm: boolean = false;

  /**
   * Novas props files
   */
  csvFile: File | null = null;
  mediaFiles: File[] = [];
  mediaMeta: Array<{
    name: string;
    size: number;
    mimeType: string;
    width?: number;
    height?: number;
    duration?: number;
  }> = [];

  //Variables form-generals
  public stepForm: number = 0;

  //Variaveis do formulario WAMD-CSV
  public formWAMDCSV!: FormGroup;
  public countrys: Array<any> = [
    { name: 'BRA', code: '55' }, // Brasil
    { name: 'USA', code: '1' }, // Estados Unidos
    { name: 'CAN', code: '1' }, // Canadá
    { name: 'ARG', code: '54' }, // Argentina
    { name: 'MEX', code: '52' }, // México
    { name: 'GBR', code: '44' }, // Reino Unido
    { name: 'FRA', code: '33' }, // França
    { name: 'GER', code: '49' }, // Alemanha
    { name: 'ITA', code: '39' }, // Itália
    { name: 'ESP', code: '34' }, // Espanha
    { name: 'CHN', code: '86' }, // China
    { name: 'JPN', code: '81' }, // Japão
    { name: 'IND', code: '91' }, // Índia
    { name: 'AUS', code: '61' }, // Austrália
    { name: 'ZAF', code: '27' }, // África do Sul
    { name: 'RUS', code: '7' }, // Rússia
    { name: 'KOR', code: '82' }, // Coreia do Sul
    { name: 'SAU', code: '966' }, // Arábia Saudita
    { name: 'TUR', code: '90' }, // Turquia
    { name: 'SWE', code: '46' }, // Suécia
  ];

  public columns: Array<any> = [
    { column: 'A', value: 0 },
    { column: 'B', value: 1 },
    { column: 'C', value: 2 },
    { column: 'D', value: 3 },
    { column: 'E', value: 4 },
    { column: 'F', value: 5 },
    { column: 'G', value: 6 },
    { column: 'H', value: 7 },
    { column: 'I', value: 8 },
    { column: 'J', value: 9 },
    { column: 'K', value: 10 },
    { column: 'L', value: 11 },
    { column: 'M', value: 12 },
    { column: 'N', value: 13 },
    { column: 'O', value: 14 },
    { column: 'P', value: 15 },
    { column: 'Q', value: 16 },
    { column: 'R', value: 17 },
    { column: 'S', value: 18 },
    { column: 'T', value: 19 },
    { column: 'U', value: 20 },
    { column: 'V', value: 21 },
    { column: 'W', value: 22 },
    { column: 'X', value: 23 },
    { column: 'Y', value: 24 },
    { column: 'Z', value: 25 },
  ];

  public columnRef: Array<any> = this.columns.map((item) => ({
    column: item.column,
    value: `[${item.column}]`,
  }));
  public handleExt: string = 'normal';
  constructor(
    private disparoService: DisparoService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    const data = moment().format('YYYY-MM-DD HH:mm:ss');
    this.formWAMDCSV = this.fb.group({
      nome: ['', [Validators.required]],
      tipodisparo: ['NORMAL', [Validators.required]],
      country: ['55', [Validators.required]],
      saturday: [0, [Validators.required]],
      sunday: [0, [Validators.required]],
      ignoreRow: [false, [Validators.required]],
      addExt: [false],
      colunaTelefone: ['0', [Validators.required]],
      canais: this.fb.array([]),
      mensagem: ['', [Validators.required]],
      ordemenvio: ['0', [Validators.required]],
      data: [data, [Validators.required]],
      tipobotao: [0, [Validators.required]],
      botoes: [0, [Validators.required]],
      hComercial: [false, [Validators.required]],
      antiSpam: ['', [Validators.required]],
      typeExt: ['normal', [Validators.required]],
      extData: ['', [Validators.required]],
    });

    this.disparoService
      .getCanaisNormal()
      .pipe(
        takeUntil(this.unsubscribe$),
        map((channels: any) =>
          channels.filter((channels: any) => channels.status === 'Conectado')
        )
      )
      .subscribe((response: any) => {
        this.listChannels = response;
      });

    this.disparoService
      .getMessagesPreDefined()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response: any) => {
        this.listMessages = response.messages;
      });
  }



  public handleSubmit() {
    if (!this.csvFile) {
      this.alertComponent.showAlert('Selecione um CSV', 'error');
      return;
    }

    this.loadingComponent.activeLoading();

    const v = this.formWAMDCSV.value;

    // 1) Monte o objeto "dados" exatamente como o backend espera
    //    (tipos coerentes: números como número; booleans como boolean;
    //     veja observações sobre ignoreRow/hComercial/antiSpam e colunaTelefone)
    const dados = {
      nome: String(v.nome),
      tipodisparo: String(v.tipodisparo), // "NORMAL" | "AGENDADO"
      country: String(v.country ?? '55'),

      saturday: Boolean(v.saturday),
      sunday: Boolean(v.sunday),

      // IMPORTANTE: seu controller exige numero inteiro
      colunaTelefone: Number(v.colunaTelefone ?? 0),

      // Estes três o controller trata como numeros/flags depois:
      // Lá você fez toInt / comparações === 1 em alguns lugares.
      // Se quer manter consistência, envie número 0/1:
      ignoreRow: v.ignoreRow ? '1' : '0', // <-- seu controller compara "1"
      hComercial: v.hComercial ? 1 : 0, // usado mais abaixo no setFlow
      antiSpam: v.antiSpam ? 1 : 0, // se seu form guarda string, converta para 0/1

      mensagem: String(v.mensagem),
      // ATENÇÃO: seu controller usa "ordemenvio" em um trecho e "ordem" em outro (bug! ver abaixo)
      ordemenvio: String(v.ordemenvio ?? '0'), // "0" mensagem primeiro | "1" mídias primeiro
      ordem: String(v.ordemenvio ?? '0'), // <-- work-around até você corrigir o controller

      data: new Date(v.data).toISOString(), // ajuste se o backend esperar outro formato
      tipobotao: String(v.tipobotao ?? 0),
      botoes: String(v.botoes ?? '[]'),

      typeExt: String(v.typeExt ?? ''),
      extData: String(v.extData ?? ''),

      // canais: o controller aceita array direto (melhor do que JSON)
      canais: (v.canais ?? []).map(String),
    };

    // 2) Construa o FormData
    const fd = new FormData();

    // Campos simples: **um único** campo 'dados' com JSON string
    fd.append('dados', JSON.stringify(dados));

    // Arquivos
    fd.append('csv', this.csvFile); // único CSV
    this.mediaFiles.forEach((f) => fd.append('midias', f)); // várias mídias

    // Se quiser mandar metadados das mídias (opcional):
    // fd.append('midiasMeta', JSON.stringify(this.mediaMeta));

    this.disparoService
      .setDisparoNormalCsv(fd)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: () => {
          this.loadingComponent.inactiveLoading();
          this.alertComponent.showAlert(
            'Disparo criado com sucesso',
            'success'
          );
          this.closeModalFinishFire();
        },
        error: (err) => {
          this.loadingComponent.inactiveLoading();
          this.alertComponent.showAlert(
            `Erro ao gerar disparo ${err?.error?.error?.message ?? ''}`,
            'error'
          );
        },
      });
  }
  public handleContinue() {
    this.stepForm += 1;
  }

  public alterHandleExt(event: Event) {
    const value = event.target as HTMLSelectElement;
    this.handleExt = value?.value;
    this.formWAMDCSV.patchValue({
      typeExt: value?.value,
      extData: '',
    });
  }

  public handleAddInputFile() {
    if (this.countInputFile < 3) {
      this.countInputFile++;
    } else {
      this.alertComponent.showAlert(
        'Voce nao pode adicionar mais de 3 arquivos!',
        'warning'
      );
    }
  }

  public handleRemoveInputFile() {
    if (this.countInputFile > 0) {
      this.countInputFile--;
      this.formWAMDCSV.value.midias.pop();
    }
  }

  //Nova versao com file em form-data
  public handleFileCsv(event: Event) {
    const file = (event.target as HTMLInputElement)?.files?.[0];
    if (!file) return;

    // opcional: validar mime
    if (file.type !== 'text/csv' && !file.name.endsWith('.csv')) {
      this.errorMessage = `Arquivo inválido: ${file.name}`;
      return;
    }

    this.errorMessage = '';
    this.csvFile = file;
  }
 

  public onFilesSelected(event: Event) {
    const list = (event.target as HTMLInputElement).files;
    if (!list || list.length === 0) return;

    const allowed = new Set([
      'application/pdf',
      'image/jpeg',
      'image/png',
      'audio/ogg',
      'video/mp4',
    ]);

    Array.from(list).forEach((file) => {
      if (!allowed.has(file.type)) {
        this.errorMessage = `Tipo não suportado: ${file.name} (${file.type})`;
        return;
      }

      this.errorMessage = '';
      this.mediaFiles.push(file);

      // cria registro de metadados
      const meta = {
        name: file.name,
        size: file.size,
        mimeType: file.type,
        width: undefined as number | undefined,
        height: undefined as number | undefined,
        duration: undefined as number | undefined,
      };
      this.mediaMeta.push(meta);

      // coletar dimensões/duração
      const url = URL.createObjectURL(file);

      if (file.type.startsWith('image/')) {
        const img = new Image();
        img.onload = () => {
          meta.width = img.width;
          meta.height = img.height;
          URL.revokeObjectURL(url);
        };
        img.src = url;
      }

      if (file.type.startsWith('video/')) {
        const video = document.createElement('video');
        video.onloadedmetadata = () => {
          meta.width = video.videoWidth;
          meta.height = video.videoHeight;
          meta.duration = Math.ceil(video.duration);
          URL.revokeObjectURL(url);
        };
        video.src = url;
      }

      if (file.type.startsWith('audio/')) {
        const audio = document.createElement('audio');
        audio.onloadedmetadata = () => {
          meta.duration = Math.ceil(audio.duration);
          URL.revokeObjectURL(url);
        };
        audio.src = url;
      }
    });
  }

  public removeMimeType(base64String: string): string {
    // Localiza a posição do delimitador `,` e retorna o conteúdo após ele
    return base64String.substring(base64String.indexOf(',') + 1);
  }

  public handleAddTextMessage(event: Event) {
    const message: any = event?.target;

    this.formWAMDCSV.patchValue({
      mensagem: this.formWAMDCSV.value.mensagem + message.value,
    });
  }

  public handleAddRefMessage(event: Event) {
    const ref: any = event?.target;

    this.formWAMDCSV.patchValue({
      mensagem: this.formWAMDCSV.value.mensagem + ref.value,
    });
  }

  public addEmoji(event: any) {
    // Garante que você está acessando o valor correto
    console.log(event.emoji.native);
    const emoji = event.emoji?.native; // Verifica se "native" existe
    if (emoji) {
      // if (this.text === '') {
      //   this.text = emoji;
      // } else {
      //   this.text += emoji; // Adiciona o emoji ao campo de texto
      // }
      this.formWAMDCSV.patchValue({
        mensagem: this.formWAMDCSV.value.mensagem + emoji,
      });
    } else {
      console.log(emoji);
    }
  }

  // Fecha o seletor ao clicar fora
  @HostListener('document:click', ['$event'])
  closeEmojiPicker(event: MouseEvent) {
    this.isEmojiPickerVisible = false;
  }

  public toggleEmojiPicker(event: Event) {
    event.stopPropagation();
    this.isEmojiPickerVisible = !this.isEmojiPickerVisible;
  }

  public handleSelectChannel(event: Event) {
    const element = event?.target as HTMLInputElement;

    if (element.checked === true) {
      this.addIdChannel(parseInt(element.value));
    } else if (element.checked === false) {
      this.removeIdChannel(parseInt(element.value));
    }
  }

  public removeIdChannel(idChannel: number): void {
    let index = this.formWAMDCSV.value.canais.splice(
      this.formWAMDCSV.value.canais.indexOf(idChannel),
      1
    );
    console.log(this.formWAMDCSV.value.canais);
  }

  public addIdChannel(idChannel: number): void {
    this.formWAMDCSV.value.canais.push(idChannel);
    console.log(this.formWAMDCSV.value.canais);
  }

  public handleIsScheduled(event: Event): void {
    const data: any = (event?.target as HTMLInputElement).checked;

    if (data === true) {
      this.isScheduled = true;
      this.formWAMDCSV.get('tipodisparo')?.setValue('AGENDADO');
      return;
    }

    this.formWAMDCSV.patchValue({
      data: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
    this.isScheduled = false;
    this.formWAMDCSV.get('tipodisparo')?.setValue('NORMAL');
  }

  public handleManualyTimeData(event: Event): void {
    const hourNow: string = (event?.target as HTMLInputElement)?.value;

    const segmentHours: any = hourNow.split(' ');

    const [hour, minutes] = hourNow.split(':');

    console.log('Horas: ', hour);
    console.log('Minutes: ', minutes);

    this.formWAMDCSV.patchValue({
      data: moment(this.formWAMDCSV.get('data')?.value, 'YYYY-MM-DD HH:mm:ss')
        .hour(parseInt(hour))
        .minute(parseInt(minutes))
        .seconds(0)
        .format('YYYY-MM-DD HH:mm:ss'),
    });

    console.log('Nova Data: ', this.formWAMDCSV.get('data')?.value);
  }

  public handleManualyDateData(event: Event): void {
    const dateSelected: string = (event?.target as HTMLInputElement)?.value;

    this.formattedDate = dateSelected;
    const [year, month, day] = dateSelected.split('-');

    console.log(`Ano ${year}, Mes: ${month}, Dia: ${day}`);

    this.formWAMDCSV.patchValue({
      data: moment(this.formWAMDCSV.get('data')?.value, 'YYYY-MM-DD HH:mm:ss')
        .date(parseInt(day))
        .month(parseInt(month) - 1)
        .year(parseInt(year))
        .format('YYYY-MM-DD HH:mm:ss'),
    });
  }

  public validFormStepOne(): boolean {
    // if (
    //   !this.formWAMDCSV.get('nome')?.valid ||
    //   !this.formWAMDCSV.get('csv')?.valid
    // )
    //   return false;

    // return true;

    const nomeCtrl = this.formWAMDCSV.get('nome');
    const nomeValido = !!nomeCtrl && nomeCtrl.valid;

    const csvValido =
      !!this.csvFile &&
      this.csvFile instanceof File &&
      this.csvFile.size > 0 &&
      (this.csvFile.type === 'text/csv' ||
        this.csvFile.name.toLowerCase().endsWith('.csv'));

    // opcional: marcar como tocado p/ exibir erros na UI
    if (!nomeValido) nomeCtrl?.markAsTouched();
    if (!csvValido) {
      // se você tiver um lugar para mensagem:
      this.errorMessage = 'Selecione um arquivo CSV válido.';
    }

    return nomeValido && csvValido;
  }

  public validFormStepTwo() {
    if (!this.formWAMDCSV.get('mensagem')?.valid) return false;

    return true;
  }

  public validFormStepThree(): boolean {
    if (this.formWAMDCSV.value.canais.length > 0) return true;

    return false;
  }

  public closeModalFireConfiguration() {
    this.selectedTypeForm = '';
    this.stepForm = 0;
    this.countInputFile = 0;
    this.formWAMDCSV.reset();
    this.closeModal.emit(1);
  }

  public closeModalFinishFire() {
    this.selectedTypeForm = '';
    this.stepForm = 0;
    this.countInputFile = 0;
    this.formWAMDCSV.reset();
    this.closeModal.emit(2);
  }

  public handleStepForm(step: number) {
    this.stepForm = step;
  }

  public handleAcceptTerm() {}

  public validCheckTerm(): boolean {
    return this.acceptTerm;
  }
}
